/**
 * 学员能力项导入 2020-07-22
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '@/tool'
let { WizTypography, WizSpin,WizTreeSelect,WizBrowserExport } = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph } = WizTypography;
import { ExportExcel } from '@/components/index'
import { modelUtils } from '@/utils'
import { WizTableForm } from '../../../common'
const abilityCheckItem = WizTableForm.Config.abilityCheckItem(this, { apiParams: { state:1,categoryState:1 } })

class StudentAbilityFileImport extends WizContainer {

  componentName = 'studentAbilityFileImport';

  constructor(props) {
    super(props);
    this.state = {
      abilityCheckItemId:null
    }
  }

  _handldImport(nextProps, nextState) {
    let o = nextProps['studentAbilityItemImport']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{str}</p>
          </div>
        ),
      })
      return true;
    } else {
      wizNotice.error("导入数据出错，请联系相关人员")
      return false;
    }
  }

  //获取模版
  _handleFile(nextProps, nextState, key) {
    let o = nextProps['studentAbilityItemExportHead']
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      // {
      //   headerName: '角色名称',
      //   field: 'name',
      //   width: 25,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      // {
      //   headerName: '角色编码',
      //   field: 'code',
      //   width: 25,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      // {
      //   headerName: '角色描述',
      //   field: 'remark',
      //   width: 50,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // }
    ]
    if (o['success']) {
      let data = o['data']
      data.forEach(element => {
        let entity = {};
        entity.headerName = element.name;
        entity.width = 20;
        entity.cellStyle = {textAlign: 'center' };
        entity.style = {alignment: { vertical: 'bottom', horizontal: 'center' }};
        columnDefs.push(entity);
      });
      WizBrowserExport({
       // title: '学员能力值导入',
        sheetName: '学员能力值导入模版',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '学员能力值导入.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  
  _getTemp(id) {
    if(!id){
      wizNotice.error("请先选择星级名称");
      return;
    }
    this.doAction({
      path: 'studentAbilityItem/exportHead',
      payload: {
        key: "studentAbilityItemExportHead",
        apiParams: {
          id:id
        }
      }
    });
  }


  /** 获取数据存到state中，调用相应接口获取数据 */
  getTrainAbilityCheckItem(values, e) {
    let row = values.valueRows;
    if (row && row[0]) {
        let data = row[0]
        this.setState({
            abilityCheckItemId: data.id
        })
    }
}


  propsAndStateOnChange = {
    studentAbilityItemImport: this._handldImport.bind(this),
    studentAbilityItemExportHead: this._handleFile.bind(this)
  }

  /**清除星级 */
  clearOnChange(nextTargetValues) {
    if(!nextTargetValues){
      this.setState({
        abilityCheckItemId: undefined,
      })
    }
  }


  _render() {
    
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '能力值导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        onClick:()=>{this._getTemp(this.state.abilityCheckItemId)},
      }
    }
    let submit = (file, fileData) => {
      if(!this.state.abilityCheckItemId){
        wizNotice.error("请先选择星级名称");
        return;
      }
      let apiPath = 'studentAbilityItem/import';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData,
            "id": this.state.abilityCheckItemId    
          }
        }
      });
    }

    let other = [
      {
        /**
         * item的参数
         */
        item: { label: '星级名称',required:true },
        /**
         * 渲染内容的方法
         */
        comp: (callback) => {
          return (
            <WizTableForm  selectType={'radio'} {...abilityCheckItem} 
            onChange={this.clearOnChange.bind(this)} 
            onSubmit={this.getTrainAbilityCheckItem.bind(this)} />

          )
        }
      }
    ]


    let { studentAbilityItemLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={studentAbilityItemLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          other={other}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { studentAbilityItem } = state;
  const studentAbilityItemImport = modelUtils.getModelEntity(studentAbilityItem, 'import');
  const studentAbilityItemExportHead = modelUtils.getModelEntity(studentAbilityItem, 'studentAbilityItemExportHead');
  
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'studentAbilityItem')
  return {
    studentAbilityItemImport: studentAbilityItemImport,
    studentAbilityItemExportHead:studentAbilityItemExportHead,
    ...load
  }
};

export default connect(mapStateToProps)(StudentAbilityFileImport);
